import eLinkIconColor from '../../assets/elink_distribution_ag_icon_color.svg';
import eLinkIconWhite from '../../assets/elink_distribution_ag_icon_white.svg';

export function ElinkIcon({ color = 'color' }: { color?: 'color' | 'white' }) {
  return (
    <img
      style={{
        height: '100%',
        width: 'auto',
      }}
      src={color === 'color' ? eLinkIconColor : eLinkIconWhite}
      alt={'eLink Distribution AG Icon'}
    />
  );
}
